import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { FullScreenLoader } from "@/App";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;

    const run = async () => {
      if (!sessionId) {
        navigate("/login", { replace: true });
        return;
      }
      try {
        const { data } = await api.post("/auth/google/session", { session_id: sessionId });
        window.history.replaceState(null, "", window.location.pathname);
        setUser(data);
        navigate(data.role === "buyer" ? "/catalog" : "/admin", { replace: true });
      } catch {
        navigate("/login?error=google", { replace: true });
      }
    };
    run();
  }, [navigate, setUser]);

  return <FullScreenLoader />;
}
